import {
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  Flex,
  Modal,
  Text
} from "@theorgchartdev/storybook";
import CentralizedModalContainer from "../../Utils/CentralizedModalContainer/CentralizedModalContainer";
import { appstr } from "@coreapp/utils/appstr";
import { useState } from "react";
import { UpdateChartMetadata } from "@/Utils/Promises";
import { useToast } from "@/providers/ToastProvider";

type ForceRefreshModalProps = {
  showForceRefreshModal: boolean;
  setShowForceRefreshModal: (show: boolean) => void;
  chartConfig: any;
};

export const ForceRefreshModal = (props: ForceRefreshModalProps) => {
  const { showForceRefreshModal, setShowForceRefreshModal, chartConfig } = props;

  const [forcePhotoReload, setForcePhotoReload] = useState<boolean>(false);
  const { addToast }: any = useToast();

  const onRefreshQueue = async () => {
    // Implement the logic to force refresh the queue here
    const refreshFlag = {
      ...chartConfig?.refreshFlag,
      needsRefresh: true,
      refreshReason: "Forced refresh via Force Refresh Modal (support login)",
      forcePhotoReload
    };

    let success;
    try {
      const result = await UpdateChartMetadata(chartConfig.ID, JSON.stringify({ refreshFlag }));
      success = result.success;
    } catch (error) {
      success = false;
    }

    if (success) {
      setShowForceRefreshModal(false);
      addToast({ message: appstr("Chart added to the refresh queue"), status: "success" });
    } else {
      addToast({ message: appstr("Generic toast error"), status: "error" });
    }
  };

  return (
    <CentralizedModalContainer show={showForceRefreshModal}>
      <Modal
        show={showForceRefreshModal}
        id="force-refresh-modal"
        minWidth="small"
        maxWidth="medium"
        centerScreen={true}
      >
        <DialogTitle divider={true} onClose={() => setShowForceRefreshModal(false)}>
          {`${appstr("Force queue refresh question")}`}
        </DialogTitle>
        <DialogContent>
          <Flex direction="column" gap="16px" padding="8px">
            <Text size="medium" modifier="medium">
              {appstr("Refresh Queue Info")}
            </Text>
            <Checkbox
              id={"photorefresh"}
              label={appstr("photoRefreshChoice")}
              size="medium"
              checked={forcePhotoReload}
              onChange={e => setForcePhotoReload(!forcePhotoReload)}
            />
          </Flex>
        </DialogContent>
        <DialogActions>
          <DialogActions.Tertiary onClick={() => setShowForceRefreshModal(false)}>
            {appstr("Cancel")}
          </DialogActions.Tertiary>
          <DialogActions.Primary onClick={onRefreshQueue}>
            {appstr("Force queue")}
          </DialogActions.Primary>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};
